import { Box, Typography } from '@mui/material'
import React from 'react'
import parse from "html-react-parser";
import {useNavigate} from 'react-router-dom'
import { useTranslation } from 'react-i18next';

function DentalClinicCard({id,title, image, description, location, contact}) {
    const navigate = useNavigate()
    const {t} = useTranslation()

  return (
    <Box onClick={() => navigate(`/dental-clinics/application/${id}`)} key={id} sx={{border : '1px solid #A9A9A9', ':hover' : {border : '1px solid #27BAC4', cursor : 'pointer'}, width : {xs : '100%', sm : '60%',md : '46%', lg : '30%'}, height : 'auto', padding : '20px', borderRadius : '10px'}}>
        <Box>
            <Box sx={{height : '200px', width : '100%', borderRadius : '10px'}} component='img' src={image}></Box>
        </Box>
        <Box sx={{mt : 2}}>
            <Box>
                <Typography sx={{fontWeight : 700, fontSize : '24px'}}>{title}</Typography>
            </Box>
            <Box sx={{mt : 1}}>
                <Typography>{Boolean(description)
                            ? parse(description)
                            : "-"}</Typography>
            </Box>
            <Box sx={{mt : 2}}>
                <Typography sx={{color : '#737373'}}><b style={{color : 'black'}}>{t("Location")}</b>: {`${location}`}</Typography>
            </Box>
            <Box sx={{mt : 1}}>
                <Typography sx={{color : '#737373'}}><b style={{color : 'black'}}>{t("Contact")}</b>: {`+${contact}`}</Typography>
            </Box>
        </Box>
    </Box>
  )
}

export default DentalClinicCard